module.exports = __webpack_public_path__ + "static/img/pay_qrpay_right@3x.b518bea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_right@3x.png
// module id = KNso
// module chunks = 1